import type { Locale } from './locale';
import { LOCALE_DEFAULT, LOCALE_EN, LOCALE_FR, LOCALES } from './locale';

const MFA_LOCALE_BY_LOCALE: Record<Locale, string> = {
  [LOCALE_EN]: 'en',
  [LOCALE_FR]: 'fr-CA',
};

export const getDefaultLocale = (): Locale => LOCALE_DEFAULT;

export const isSupportedLocale = (value: unknown): value is Locale => (
  typeof value === 'string' && (LOCALES as readonly string[]).includes(value)
);

export const sanitizeLocale = (locale: unknown): Locale => {
  if (!locale) {
    return getDefaultLocale();
  }

  if (isSupportedLocale(locale)) {
    return locale;
  }

  return getDefaultLocale();
};

export const getMfaLocale = (locale?: string): string | undefined => {
  if (!locale) {
    return MFA_LOCALE_BY_LOCALE[getDefaultLocale()];
  }

  return isSupportedLocale(locale) ? MFA_LOCALE_BY_LOCALE[locale] : undefined;
};

export const getLocaleFromPathname = (pathname = '/'): Locale => {
  const firstPathSegment = pathname.split('/')[1];

  return sanitizeLocale(firstPathSegment);
};

export const toLocale = (value: unknown): Locale => (isSupportedLocale(value) ? value : LOCALE_DEFAULT);
